import React from 'react';

import { IconClose } from '@pkg/assets/icons';

import { IconArrowBack } from './icons';

import { Action, IconWrapper, Link, Wrapper } from './CloseAction.style';

export interface CloseActionProps {
    ariaLabel?: string;
    back?: boolean;
    disabled?: boolean;
    url?: string;
    onAction?: () => void;
}

export function CloseAction({ ariaLabel, back = false, disabled = false, url, onAction }: CloseActionProps) {
    const actionIcon = back ? <IconArrowBack /> : <IconClose />;
    const iconMarkup = <IconWrapper>{actionIcon}</IconWrapper>;

    const actionMarkup = url ? (
        <Link to={url}>{iconMarkup}</Link>
    ) : (
        <Action aria-label={ariaLabel} disabled={disabled || !onAction} onClick={onAction}>
            {iconMarkup}
        </Action>
    );

    return <Wrapper $back={back}>{actionMarkup}</Wrapper>;
}
